<template>
	<empty-state class="no-data-tip" :title="tip" :hint="hint" :icon="icon"></empty-state>
</template>

<script>
import EmptyState from './EmptyState.vue';

export default {
	name: "noDataTip",
	components: {
		EmptyState
	},
	props: {
		tip: {
			type: String,
			default: '没有数据'
		},
		hint: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: 'el-icon-document'
		}
	}
}
</script>

<style lang="scss" scoped>
.no-data-tip {
	min-height: 100%;
}
</style>
